<template>
<div v-if="fund && fund.ticker">
    <p class="title is-3 has-text-centered">
      {{ fund.ticker.full_name }}
    </p>
    <p class="subtitle is-size-7 is-italic has-text-centered">
      Holdings as reported to the Securities and Exchange Commission on {{fund.ticker.filing_date}}
    </p>
    
    <div class="has-text-centered" style="margin: 20px 0;">
      <router-link 
        :to="{ path: '/advisor/checkup/auto-portfolio', query: { fund_screener_fund: fund.ticker.symbol } }"
        target="_blank"
        class="button is-primary">
        View Portfolio Analysis
      </router-link>
    </div>
    
    
  <div class="jonbox columns">
    <div class="column is-one-quarter">
      <span class="icon is-medium">
        <i class="fas fa-building fa-2x"></i>
      </span>
      <span class="title is-5">{{ fund.ticker.company_name }}</span>
    </div>
    <div class="column is-one-fifth">
      <span class="title is-5 has-text-centered">{{ fund.ticker.symbol }}</span>
    </div>
    <div class="column is-one-fifth has-text-centered">
      <p class="heading ">
        Fees
      </p>
      <p class="criteria">{{ (fund.ticker.expense_ratio * 100).toFixed(2) }}%</p>
      <!-- <p class="criteria">No minimum</p> -->
    </div>
    <div class="column is-one-fifth has-text-centered">
      <p class="heading ">
        Net Assets
      </p>
      <p class="criteria">{{ fund.ticker.total_value.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 0}) }}</p>
    </div>
  </div>
  <br>

  <div v-if="slicedStories.length > 0">
    <div class="jonbox">
      <p class="title is-5">
        Shareholder Engagement
        <b-tooltip
          multilined
          type="is-light"
          label="External links are provided for convenience only. YourStake.org is not responsible for the content of any external sites, and YourStake.org does not guarantee that external links will remain available."
        >
          <b-icon pack="fas" icon="info-circle"/>
        </b-tooltip>
      </p>

      <!-- <div class="column is-one-fifth has-text-centered">
        <p class="heading">Voting Alignment</p>
        <p>--%</p>
      </div> -->
      <!-- <div class="column is-one-fifth">
        <p class="hearing has-text-centered">Tally of Changes</p>
        <p class="subtitle is-4 has-text-centered">2</p>
      </div> -->

      <div class="content criteria csscolumns minheight">
        <ul>
          <li v-for="story in slicedStories">
            <p class='subtitle is-7' target="blank">
              {{ story.title }}
            &nbsp;
              <small>
                <a class="has-text-link" target="blank" v-bind:href="story.source_link">&#x1f517;</a>
              </small>
            </p>
          </li>
        </ul>
      </div>
      <div
        v-if="detailedFund.stories && detailedFund.stories.length > storySlice"
        class="block has-text-centered help"
      >
        Showing {{ storySlice }} of {{ detailedFund.stories.length }} stories
        <br>
        <b-button type="is-ghost" size="is-small" v-on:click="() => { this.storySlice = this.detailedFund.stories.length }">See All</b-button>
      </div>
    </div>
  </div>
  <br>
  <div class="columns">
    <div class="column is-one-fifth">
      <p class="title">
        &nbsp;
        &nbsp;
        &nbsp;
        Heatmap
      </p>
    </div>
    <div class="column is-half">
      <div class="columns is-vcentered">
        <div class="column">
          <b-field>
            <b-radio-button v-model="filterMetricsByValues"
              native-value="no"
              type="is-primary is-light is-outlined"
            >
              <span class="icon is-small"><i class="fas fa-film" aria-hidden="true"></i></span>
              <span>All Metrics</span>
            </b-radio-button>

            <b-radio-button v-model="filterMetricsByValues"
              native-value="yes"
              type="is-primary is-light is-outlined"
            >
              <span class="icon is-small "><i class="far fa-file-alt" aria-hidden="true"></i></span>
              <span>Value Sets</span>
            </b-radio-button>
          </b-field>
        </div>
        <div class="column">
          <div class="tags" v-if="filterMetricsByValues === 'yes'">
            <ValueTag
              v-for="(set, index) in values"
              v-bind:screen_set="set"
            />
          </div>
        </div>
      </div>
    </div><!-- half column-->
    <div class="column is-one-quarter has-text-right">
      <p class="heading">
        Benchmark
      </p>
      <p class="title is-7">
      <b-tooltip
        multilined
        type="is-light"
        v-bind:label="'Benchmarked to fund: ' + fund.ticker.benchmark_symbol"
      >
      <em>
        {{ fund.ticker.benchmark_description }}
      </em>
        
      </b-tooltip>
        
      </p>

    </div>
  </div><!-- columns-->
  <p class=" has-text-centered help">
    <em>Numbers represent percentiles of the performance of a metric compared to its relevant universe. Click through for more details.</em> 
  </p>
  
  <br>
  <div class="line1"></div>


  <div class="columns jonbox2" v-if="detailsLoaded" v-for="issue in issues">
    <div class="column is-one-quarter has-text-centered has-text-grey-light" v-if="metricsForIssue(issue.name).length > 0">
      <p class="title is-5">
        {{ issue.name }}
      </p>
      <span class="icon is-medium">
        <i v-bind:class="'fas fa-2x ' + issue.icon"></i>
      </span>
    </div>
    <div class="column is-three-quarters">
      <div class="metricflex">
        <div
          v-for="metric in filteredMetricsByIssue(issue.name)"
          :key="metric.id"
          class="jonbox metricard"
          :class="{ 'low-coverage': metric.coverage <= 0.01 }"
          :style="{
            backgroundColor: colorScale()(metric.percentile),
            filter: metric.coverage <= 0.01
                    ? 'grayscale(100%) opacity(0.5)'
                    : ''
          }"
        >
          <!-- tooltip for low coverage -->
          <b-tooltip
            v-if="metric.coverage <= 0.01"
            multilined
            type="is-light"
            label="Coverage is very low (<1%)"
          >
            <a
              :href="`/fund-lookthrough-metric/${metric.id}/${fund.ticker.symbol}/`"
              target="_blank" rel="noreferrer noopener"
            >
              <p class="title is-7 has-text-centered">{{ metric.name }}</p>
              <p class="title is-5 has-text-centered">{{ (metric.percentile*100).toFixed(0) }}</p>
            </a>
          </b-tooltip>

          <!-- normal display when coverage > 0.01 -->
          <template v-else>
            <a
              :href="`/fund-lookthrough-metric/${metric.id}/${fund.ticker.symbol}/`"
              target="_blank" rel="noreferrer noopener"
            >
              <p class="title is-7 has-text-centered">{{ metric.name }}</p>
              <p class="title is-5 has-text-centered">{{ (metric.percentile*100).toFixed(0) }}</p>
            </a>
          </template>
        </div>
      </div>

    </div>
  </div>
  <div class="jsonbox" v-if="$root.advisor?.hasFeature('ESG Mandate')">

    <div class="column"><div>ESG Mandate</div><div>{{ fund.ticker.esg_mandate ? "Yes" : "No" }} </div></div>
    <div class="column"><div>Fund Family</div><div>{{ fund.ticker.fund_family }} </div></div>
    <div class="column"><div>Share Class</div><div>{{ fund.ticker.share_class }} </div></div>
    <div class="column"><div>Strategy Narrative</div><div v-html="fund.ticker.strategy_narrative" /></div>
    <div class="column" v-if="fund.ticker.principal_investment_strategy"><div>Principal Investment Strategy</div><div v-html="fund.ticker.principal_investment_strategy"/></div>
    </div>

  </div>
</div>

</template>

<script>
import eventBus from '@frontend/shared/EventBus.js';
import chroma from 'chroma-js';

import ValueTag from '@frontend/dash3/js/components/ValueTag.vue';

export default {
  name: 'FundDetailView',
  data() {
    return {
      key: this.$route.path,
      detailedFund: {},
      detailsLoaded: false,
      filterMetricsByValues: 'yes', // TODO: Proper way to do boolean on radio with buefy????

      issues: [
        {name: 'Accountability', icon: 'fa-sun'},
        {name: 'Environment', icon: 'fa-globe'},
        {name: 'Equal Opportunity', icon: 'fa-road'},
        {name: 'Health', icon: 'fa-heartbeat'},
        {name: 'Human Rights', icon: 'fa-universal-access'},
      ],

      storySlice: 6,

      fund: {},
      metrics: {
        a: [],
        byId: {},
      },
    }
  },
  props: {
    initialFund: Object,
    values: {
      type: Array,
      default: () => {
        return [];
      }
    },
    initialMetrics: Object,
    backTo: Object,
  },
  components: {
    ValueTag,
  },
  methods: {
    closeDetail: function() {
      eventBus.$emit('FundDetailView:close');
    },
    colorScale: function(percentile) {
      return chroma.scale(['rgb(224, 101, 87)', 'white', 'rgb(91, 227, 123)']).domain([0, 1]);
    },
    metricsForIssue: function(issueName) {
      return (this.detailedFund.impact_factors || []).filter((itm) => {
        return itm.details?.subcategory?.[0]?.esgissue?.name === issueName;
      })
    },
    loadDetails: async function() {
      let fundData;
      if (this.fund && this.fund.ticker) {
        let fundResponse = await fetch(`/api/v1/explore/funds/${this.fund.ticker__id}/`);
        fundData = await fundResponse.json();
      }
      else if (this.$route.params.symbol) {
        let fundResponse = await fetch(`/api/v1/explore/funds/?exact_symbol=${this.$route.params.symbol}`);
        let fundSearch = await fundResponse.json()
        let fundDetailResp = await fetch(`/api/v1/explore/funds/${fundSearch.funds[0].ticker.id}/`);
        fundData = await fundDetailResp.json();
        this.fund = fundSearch.funds[0];
      } else {
        return;
      }
      if (this.initialFund) {
        this.fund = { ...this.initialFund };
      }

      if (this.initialMetrics) {
        this.metrics = { ...this.initialMetrics };
      } else {
        let metricResponse = await fetch('/api/v1/impact_factors/');
        let metricData = await metricResponse.json();
        metricData.metrics.forEach((itm) => {
          this.metrics.byId[itm.id] = itm;
          this.metrics.a.push(itm);
        });
      }

      fundData.fund.impact_factors.forEach((itm, idx, arr) => {
        console.log("Getting details")

        itm.details = this.metrics.byId[itm.metric_description];
      });
      this.detailedFund = fundData.fund;
      this.$nextTick(() => {
        this.detailsLoaded = true;
      });
    },
  },
  computed: {
    metricsFromValues: function() {
      return this.values.reduce((acc, val) => {
        acc.push(...val.metrics.map((itm) => {
          return itm.metric_description;
        }));
        return acc;
      }, []);
    },
    slicedStories: function() {
      if (!this.detailedFund || !this.detailedFund.stories || this.detailedFund.stories.length === 0) {
        return [];
      }
      return this.detailedFund.stories.slice(0, this.storySlice);
    },
    filteredMetricsByIssue() {
      return (issueName) => {
        return (this.detailedFund.impact_factors || [])
          .filter(item =>
            item.details?.subcategory?.[0]?.esgissue?.name === issueName
          )
          .filter(metric =>
            this.filterMetricsByValues === 'no' ||
            this.metricsFromValues.includes(metric.metric_description)
          );
      };
    },
  },
  watch: {},
  mounted: async function() {
    if (this.values.length === 0) {
      this.filterMetricsByValues = 'no';
    }
  },
  created: async function() {
    await this.loadDetails();
  },
};
</script>

<style lang="scss" scoped>
  .jonbox {
    padding: 1rem;
  }
  .tabs.is-toggle li.is-active a
  {
    background-color: var(--black-95);
    border-color: var(--black-95);
  }
  h1 {
    color: red;
  }
  .fund-screening-grid {
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: 12rem auto;
    grid-template-areas:
    "filters metadata"
    "results portfolio";
    grid-gap: 1rem;
  }
  .filters {
    grid-area: filters;
  }
  .metadata {
    grid-area: metadata;
  }
  .results {
    grid-area: results;
  }
  .portfolio {
    grid-area: portfolio;
  }
  .fund-detail-page {
    font-family: "Inter", "Inter Variable", "Roboto", "Segoe UI", "Segoe UI Variable", "SF Pro", "Helvetica", "Arial", sans-serif;
    color: rgb(49,47,48);
  }
  .metricard {
    width: 10rem;
    height: 7rem;
    padding: .5rem;
    margin: .5rem;
  }
  .metricflex {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
  }
  .jonbox {
      border-radius: 5px;
      border: solid 1px #d8d8d8;
  }
  .jonboxcolumn {
      border-radius: 5px;
      border: solid 1px #d8d8d8;
      padding: 1.25rem;
      display: block;
  }
  .jonbox2 {
    /* three sided border, bottomless */
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      border-top: solid 1px #d8d8d8;
      border-left: solid 1px #d8d8d8;
      border-right: solid 1px #d8d8d8;
  }
  .csscolumns {
    column-count: 4;
    column-gap: 2em;
    column-rule-style: none;
    column-rule-width: 1px;
    column-rule-color: var(--black-95);
    column-fill: auto;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .minheight {
    min-height: 5rem;
  }

</style>
